import { render, staticRenderFns } from "./products-slider.vue?vue&type=template&id=7febb18e&scoped=true&"
import script from "./products-slider.vue?vue&type=script&lang=js&"
export * from "./products-slider.vue?vue&type=script&lang=js&"
import style0 from "./products-slider.vue?vue&type=style&index=0&id=7febb18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7febb18e",
  null
  
)

export default component.exports